module.exports = __webpack_public_path__ + "static/otherhero_mobile-9be0d2a9095600e88ba13daab2cc7de8.jpg";